module.exports = __webpack_public_path__ + "static/img/doubao_avatar.14e7d1e4.png";